import { ChangeDetectionStrategy, Component, input, linkedSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Country } from '@warema/shared/models';
import {
    PopupContent,
    WaremaButton,
    WaremaDropdown,
    WaremaDropdownOption,
    WaremaFieldLabel,
    WaremaInputField,
} from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-country-dialog',
    templateUrl: './country-dialog.component.html',
    styleUrls: ['./country-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, WaremaFieldLabel, WaremaDropdown, WaremaDropdownOption, WaremaInputField, WaremaButton],
})
export class CountryDialogComponent extends PopupContent<Country> {
    public readonly currentCountry = input<Country | null>(null);
    public readonly countries = input.required<Array<Country>>();

    public readonly selectedCountry = linkedSignal<Country | null>(() => this.currentCountry());

    public onCountrySelectionChange($event: CustomEvent<string>): void {
        const countryISOCode = $event.detail;
        const newSelectedCountry = this.countries().find(country => country.value === countryISOCode);

        if (newSelectedCountry === undefined) {
            throw new TypeError('The value was promised to always be there!');
        } else {
            this.selectedCountry.set(newSelectedCountry);
        }
    }
}
